/** `performance.mark` lifecycle helper — best-effort, never throws. */
export function mark(name: string): void {
  try {
    window.performance?.mark?.(name);
  } catch {
    // performance API unavailable — marks are diagnostics only.
  }
}

export type Logger = (message: string, ...rest: unknown[]) => void;

/** Verbose console logging, gated by `data-debug="true"`. */
export function createLogger(debug: boolean): Logger {
  return (message: string, ...rest: unknown[]): void => {
    if (debug) console.info(`[Ekho] ${message}`, ...rest);
  };
}

/**
 * Health signal: fire a namespaced `ekho:error` event on `window` before
 * deactivating so the host page (or a monitoring snippet) can observe failures.
 */
export function dispatchErrorEvent(stage: string, code: string): void {
  try {
    window.dispatchEvent(new CustomEvent('ekho:error', { detail: { stage, code } }));
  } catch {
    // CustomEvent unsupported — nothing else to do.
  }
}

/** Inject a `<link rel="preconnect">` (and dns-prefetch fallback) for the CDN. */
export function injectPreconnect(nonce: string | null): void {
  const PRECONNECT_HOST = 'https://js.ekho.com';
  for (const rel of ['preconnect', 'dns-prefetch']) {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = PRECONNECT_HOST;
    if (nonce) link.nonce = nonce;
    document.head.appendChild(link);
  }
}
